import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Popconfirm, PopconfirmProps } from "antd";
import React from "react";

interface CustomPopconfirmProps extends PopconfirmProps {
	children: React.ReactNode;
	title: React.ReactNode;
	handleConfirm: () => void | Promise<void>;
}

function CustomPopconfirm({
	children,
	title,
	handleConfirm,
	...restprops
}: CustomPopconfirmProps) {
	return (
		<Popconfirm
			icon={
				restprops.icon === undefined ? (
					<ExclamationCircleOutlined style={{ color: "grey" }} />
				) : (
					restprops.icon
				)
			}
			title={title}
			placement="topRight"
			okText="Confirm"
			onConfirm={handleConfirm}
			{...restprops}
		>
			{children}
		</Popconfirm>
	);
}

export default CustomPopconfirm;
